import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2db34200"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "voiceselection"
};
var _hoisted_2 = {
  "class": "container"
};
var _hoisted_3 = {
  "class": "avatar__name"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "wrapper"
};
var _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"slices\" data-v-2db34200><div class=\"marker\" style=\"--bg:#ffffff;--trigg:10;\" data-v-2db34200></div><div class=\"marker\" style=\"--bg:#e1ffda;--trigg:30;\" data-v-2db34200></div><div class=\"marker\" style=\"--bg:#a6ff90;--trigg:60;\" data-v-2db34200></div><div class=\"marker\" style=\"--bg:#a6ff90;--trigg:70;\" data-v-2db34200></div><div class=\"marker\" style=\"--bg:#69f945;--trigg:85;\" data-v-2db34200></div><div class=\"marker\" style=\"--bg:#33ff00;--trigg:90;\" data-v-2db34200></div></div>", 1);
var _hoisted_7 = {
  "class": "gauge-center"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "label"
  }, "Bond", -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "number"
  }, "%", -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "voiceselection__title"
  }, "Main Settings", -1);
});
var _hoisted_11 = {
  key: 0,
  "class": "toggleHolder"
};
var _hoisted_12 = {
  key: 0,
  "class": "toggleLabel"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "voiceselection__title"
  }, "Voice Settings", -1);
});
var _hoisted_14 = {
  key: 0
};
var _hoisted_15 = {
  "class": "voiceselection__option"
};
var _hoisted_16 = {
  "class": "voiceselection__option"
};
var _hoisted_17 = {
  "class": "voiceselection__option"
};
var _hoisted_18 = ["value"];
var _hoisted_19 = {
  style: {
    "margin-bottom": "80px"
  }
};
var _hoisted_20 = ["value"];
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "for": "rate"
  }, "Speaking Rate", -1);
});
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "voiceselection__title"
  }, "Cloud Voice Settings", -1);
});
var _hoisted_23 = {
  "class": "fps__container"
};
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, " Change FPS ", -1);
});
var _hoisted_25 = {
  "class": "fps__container"
};
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, " Change # Frames to remove ", -1);
});
var _hoisted_27 = {
  "class": "fps__container"
};
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, " Delay in speaking vs animation start (in MS) ", -1);
});
var _hoisted_29 = {
  "class": "fps__container"
};
var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, " Brilliance Pause Word ", -1);
});
var _hoisted_31 = {
  "class": "fps__container"
};
var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, " Brilliance Continue Word ", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;
  var _component_mainMenuNavigationItem = _resolveComponent("mainMenuNavigationItem");
  var _component_WalkthroughPointer = _resolveComponent("WalkthroughPointer");
  var _component_ToggleComponent = _resolveComponent("ToggleComponent");
  var _component_settingsItem = _resolveComponent("settingsItem");
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_AccordionTabs = _resolveComponent("AccordionTabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_mainMenuNavigationItem, {
    breadcrumbs: $props.avatarSettings.breadcrumbs,
    menuItems: $props.avatarSettings.menuItems,
    onNavChange: _ctx.clickEvent
  }, null, 8, ["breadcrumbs", "menuItems", "onNavChange"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
    "class": "change-avatar-button",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.openAvatarSelector && $options.openAvatarSelector.apply($options, arguments);
    })
  }, "Change AIVitar"), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$store.state.avatar), 1), _createElementVNode("img", {
    "class": "user-image",
    src: "".concat(_ctx.$store.state.selectedGalleryAvatar.profileVideo || _ctx.$store.state.selectedGalleryAvatar.image),
    alt: "User Image"
  }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    "class": "gauge",
    style: _normalizeStyle($options.getGaugeStyle())
  }, [_hoisted_6, _createElementVNode("div", {
    "class": "needle",
    style: _normalizeStyle($options.getNeedleStyle())
  }, null, 4), _createElementVNode("div", _hoisted_7, [_hoisted_8, _ctx.$store.state.TutorialPointerLoveMeter ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0
  })) : _createCommentVNode("", true), _hoisted_9])], 4)])]), _createVNode(_component_AccordionTabs, {
    "class": "tabs",
    tabNames: [{
      tabName: 'Main Settings',
      slotName: 'main'
    }, {
      tabName: 'Voice Settings',
      slotName: 'voice'
    }, {
      tabName: 'Brilliance Settings',
      slotName: 'brilliance'
    }]
  }, {
    main: _withCtx(function () {
      return [_hoisted_10, _ctx.$store.state.testingAccount && _ctx.$store.state.featureEnabledGemini ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_ctx.$store.state.testingAccount ? (_openBlock(), _createElementBlock("div", _hoisted_12, "AI Model")) : _createCommentVNode("", true), _createTextVNode(" Default "), _createVNode(_component_ToggleComponent, {
        "class": "toggle",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return $options.updateAI();
        }),
        active: _ctx.$store.state.aiModel === 'gemini'
      }, null, 8, ["active"]), _createTextVNode(" Gemini ")])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.VoiceSettings, function (setting) {
        return _openBlock(), _createElementBlock("div", {
          "class": "settingsitem__holder",
          key: setting.label
        }, [_createVNode(_component_settingsItem, {
          label: setting.label,
          actionLabel: setting.actionLabel ? 'Click to Activate' : setting.actionLabel,
          icon: setting.icon,
          storeItem: setting.storeItem,
          alwaysActive: setting.alwaysActive,
          proFeature: setting.proFeature || false,
          flipLogic: setting.flipLogic || false,
          isEnabled: !setting.flipLogic ? _ctx.$store.state[setting.storeItem] || setting.alwaysActive : !_ctx.$store.state[setting.storeItem] || setting.alwaysActive,
          description: setting.description,
          onClick: function onClick($event) {
            return setting.clickEvent ? _this[setting.clickEvent]() : null;
          }
        }, null, 8, ["label", "actionLabel", "icon", "storeItem", "alwaysActive", "proFeature", "flipLogic", "isEnabled", "description", "onClick"])]);
      }), 128))];
    }),
    voice: _withCtx(function () {
      return [_hoisted_13, $data.selectedVoice != null ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, "lang: " + _toDisplayString($data.selectedVoice.lang), 1), _createElementVNode("span", _hoisted_16, "name: " + _toDisplayString($data.selectedVoice.name), 1), _createElementVNode("span", _hoisted_17, "URI: " + _toDisplayString($data.selectedVoice.voiceURI), 1)])) : _createCommentVNode("", true), _createTextVNode(" Language "), _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return $data.selectedLanguage = $event;
        }),
        "class": "selector"
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.languages, function (language) {
        return _openBlock(), _createElementBlock("option", {
          key: language.label,
          value: language.value
        }, _toDisplayString(language.name), 9, _hoisted_18);
      }), 128))], 512), [[_vModelSelect, $data.selectedLanguage]]), _createElementVNode("div", _hoisted_19, [_createTextVNode("Voice "), _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return $data.selectedVoice = $event;
        }),
        "class": "selector"
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.voices, function (voice) {
        return _openBlock(), _createElementBlock("option", {
          key: voice.voiceURI,
          value: voice
        }, _toDisplayString(voice.name) + " - " + _toDisplayString(voice.lang), 9, _hoisted_20);
      }), 128))], 512), [[_vModelSelect, $data.selectedVoice]])]), _createElementVNode("div", null, [_hoisted_21, _withDirectives(_createElementVNode("input", {
        type: "range",
        min: "0.1",
        max: "1.25",
        step: "0.05",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return $data.voiceRate = $event;
        })
      }, null, 512), [[_vModelText, $data.voiceRate]]), _createTextVNode(_toDisplayString($data.voiceRate), 1)])];
    }),
    cloud: _withCtx(function () {
      return [_hoisted_22];
    }),
    Speech: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_23, [_createVNode(_component_font_awesome_icon, {
        icon: "fa-keyboard",
        "class": _normalizeClass({
          ConversationSettings__icon: true,
          'ConversationSettings__icon--active': true
        }),
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return _ctx.toggleTextVoice();
        })
      }), _hoisted_24, _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return $data.fps = $event;
        }),
        type: "number",
        min: "1",
        max: "800",
        step: "1",
        "class": "fps__input"
      }, null, 512), [[_vModelText, $data.fps]]), _createElementVNode("button", {
        "class": "fps__button",
        onClick: _cache[7] || (_cache[7] = function ($event) {
          return $options.setFPS();
        })
      }, "Set FPS")]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_font_awesome_icon, {
        icon: "fa-keyboard",
        "class": _normalizeClass({
          ConversationSettings__icon: true,
          'ConversationSettings__icon--active': true
        }),
        onClick: _cache[8] || (_cache[8] = function ($event) {
          return _ctx.u();
        })
      }), _hoisted_26, _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return $data.framesToRemove = $event;
        }),
        type: "number",
        min: "1",
        max: "800",
        step: "1",
        "class": "fps__input"
      }, null, 512), [[_vModelText, $data.framesToRemove]]), _createElementVNode("button", {
        "class": "fps__button",
        onClick: _cache[10] || (_cache[10] = function ($event) {
          return $options.setFramesToRemove();
        })
      }, "Set Frames")]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_font_awesome_icon, {
        icon: "fa-keyboard",
        "class": _normalizeClass({
          ConversationSettings__icon: true,
          'ConversationSettings__icon--active': true
        }),
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return _ctx.u();
        })
      }), _hoisted_28, _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
          return $data.delayInSpeaking = $event;
        }),
        type: "number",
        min: "1",
        max: "5000",
        step: "1",
        "class": "fps__input"
      }, null, 512), [[_vModelText, $data.delayInSpeaking]]), _createElementVNode("button", {
        "class": "fps__button",
        onClick: _cache[13] || (_cache[13] = function ($event) {
          return $options.setDelayInSpeaking();
        })
      }, "Set Delay")])];
    }),
    brilliance: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_29, [_hoisted_30, _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
          return $data.pauseWord = $event;
        }),
        type: "text",
        "class": "input"
      }, null, 512), [[_vModelText, $data.pauseWord]]), _createElementVNode("button", {
        "class": "fps__button",
        onClick: _cache[15] || (_cache[15] = function ($event) {
          return $options.savePause();
        })
      }, "Save")]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
          return $data.continueWord = $event;
        }),
        type: "text",
        "class": "input"
      }, null, 512), [[_vModelText, $data.continueWord]]), _createElementVNode("button", {
        "class": "fps__button",
        onClick: _cache[17] || (_cache[17] = function ($event) {
          return $options.saveContinue();
        })
      }, "Save")])];
    }),
    _: 1
  })]);
}